<script setup lang="ts">
import * as echarts from 'echarts'
import { onMounted, onUnmounted, reactive, ref } from 'vue'

// 页面配置
definePage({
  name: 'industry-sector',
  meta: {
    title: '行业板块',
  },
})

const ListType = ref(true)
// // 排序状态
// const sortConfig = reactive({
//   field: 'change', // 排序字段
//   direction: 'desc', // 排序方向：'asc'升序，'desc'降序
// })

// 行业排名数据
const industryRanking = reactive([
  {
    industry: '银行',
    netFlow: '+7.87亿',
    change: 7.87,
    leadingStock: '汇丰控股',
  },
  {
    industry: '科技',
    netFlow: '+5.42亿',
    change: 5.23,
    leadingStock: '腾讯控股',
  },
  {
    industry: '电讯',
    netFlow: '-3.14亿',
    change: -3.14,
    leadingStock: '中国移动',
  },
  {
    industry: '能源',
    netFlow: '+4.21亿',
    change: 4.32,
    leadingStock: '中石油',
  },
  {
    industry: '医疗',
    netFlow: '+2.98亿',
    change: 3.89,
    leadingStock: '药明生物',
  },
  {
    industry: '消费',
    netFlow: '-1.76亿',
    change: -2.76,
    leadingStock: '美团',
  },
  {
    industry: '地产',
    netFlow: '-2.34亿',
    change: -2.15,
    leadingStock: '万科企业',
  },
  {
    industry: '金融',
    netFlow: '+6.53亿',
    change: 6.45,
    leadingStock: '中国平安',
  },
])
// 排序函数
// ECharts 实例
const chartRef = ref<HTMLDivElement | null>(null)
let chartInstance: echarts.ECharts | null = null

// 初始化图表
function initChart() {
  if (!chartRef.value) {
    return
  }

  // 创建ECharts实例
  chartInstance = echarts.init(chartRef.value)

  // 配置项 - 使用treemap展示多个矩形块，铺满整个容器
  const option = {
    tooltip: {
      trigger: 'item',
      formatter(params: any) {
        return `${params.name}<br />${params.value}%`
      },
    },
    series: [
      {
        type: 'treemap',

        // 顶层数据，每个行业一个块
        data: [
          {
            name: '银行',
            value: 7.87,
            itemStyle: {
              color: '#8C000D', // 红色表示资金流入
            },
          },
          {
            name: '电讯',
            value: 3.14,
            type: 1,
            itemStyle: {
              color: '#00613C ', // 绿色表示资金流出
            },
          },
          {
            name: '科技',
            value: 5.23,
            itemStyle: {
              color: '#8C000D',
            },
          },
          {
            name: '地产',
            value: 2.15,
            type: 1,
            itemStyle: {
              color: '#00613C ',
            },
          },
          {
            name: '能源',
            value: 4.32,
            itemStyle: {
              color: '#8C000D',
            },
          },
          {
            name: '医疗',
            value: 3.89,
            itemStyle: {
              color: '#8C000D',
            },
          },
          {
            name: '消费',
            value: 2.76,
            type: 1,
            itemStyle: {
              color: '#00613C ',
            },
          },
          {
            name: '金融',
            value: 6.45,
            itemStyle: {
              color: '#8C000D',
            },
          },
        ],
        label: {
          show: true,
          fontSize: 12,
          color: '#fff',
          formatter: (params: any) => {
            const data = params.data

            // 根据 type 选择不同的样式标签
            if (data.type === 1) {
              return `{stockName|${params.name}}\n{sectorValue|-${params.value}%}`
            }
            else {
              return `{stockName|${params.name}}\n{stockValue|${params.value}%}`
            }
          },
          position: 'insideLT',
          paddingLeft: '15px',
          distance: 8,
          rich: {
            stockName: { color: '#fff', fontSize: 14, lineHeight: 14, marginBottom: 2, fontWeight: 500 },
            stockValue: { color: '#E51A2D', fontSize: 14 },
            sectorValue: { color: '#22A875', fontSize: 14 },
          },
        },
        upperLabel: {
          show: false, // 隐藏上层标签
        },
        itemStyle: {
          // borderColor: '#fff',
          // borderWidth: 0,
          // gapWidth: 0, // 增加间隙使块之间有分隔
          borderColor: '#333',
          borderWidth: 1,
          gapWidth: 1,
        },
        levels: [
          // 只保留第一层，不显示子层级
          {
            itemStyle: {
              // borderColor: '#fff',
              // borderWidth: 0,
              // gapWidth: 0,
              borderColor: '#333',
              borderWidth: 1,
              gapWidth: 0,
            },
            upperLabel: {
              show: false,
            },
          },
        ],
        // 铺满容器的设置
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        // 布局方向
        sort: undefined, // 使用默认排序
        // 确保填充整个容器
        nodeClick: false, // 禁用节点点击，避免进入下钻
        roam: false,
        labelLayout: {
          hideOverlap: true, // 隐藏重叠的标签
          draggable: false,
        },
        breadcrumb: {
          show: false,

        },
      },
    ],
    // 全局背景色
    backgroundColor: 'transparent',
  }

  chartInstance.setOption(option)

  // 监听窗口大小变化，调整图表大小
  window.addEventListener('resize', () => {
    if (chartInstance) {
      chartInstance.resize()
    }
  })
}

// 组件挂载后初始化图表
onMounted(() => {
  initChart()
})

// 组件卸载前清理
onUnmounted(() => {
  if (chartInstance) {
    chartInstance.dispose()
  }
})
</script>

<template>
  <FmPageLayout navbar :search="false" back>
    <div class="fund-flow-page">
      <Notice />
      <div class="icon-group">
        <img v-if="ListType" src="@/assets/images/icon (4).png" alt="" @click="ListType = true">
        <img v-else src="@/assets/images/icon (3).png" alt="" @click="ListType = true">
        <img v-if="ListType" src="@/assets/images/icon (1).png" alt="" @click="ListType = false">
        <img v-else src="@/assets/images/icon (2).png" alt="" @click="ListType = false">
      </div>
      <!-- 资金流向图表 -->
      <div v-show="ListType" class="flow-chart">
        <div ref="chartRef" class="chart-container" />
      </div>

      <div v-if="!ListType" class="ranking-table">
        <vxe-table
          header-row-class-name="table-header" :data="industryRanking"
        >
          <vxe-column field="industry" title="模块名称" width="50%" />
          <vxe-column field="change" title="涨跌" width="27%" sortable align="right">
            <template #default="{ row }">
              <div :class="row.change > 0 ? 'bg-[#E51A2D]' : 'bg-[#22A875]'" class="w-fit rounded-4px px-15px py-9px color-[#fff]">
                {{ `${row.change > 0 ? '+' : ''}` }}{{ row.change }}%
              </div>
            </template>
          </vxe-column>
          <vxe-column field="leadingStock" title="领涨股" width="23%" align="right" />
        </vxe-table>
      </div>
    </div>
  </FmPageLayout>
</template>

<style scoped lang="scss">
.fund-flow-page {
  min-height: 100%;
  background-color: #fff;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 16px 16px 0;
  color: white;
  background-color: #007aff;
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
}

.back-btn {
  padding: 8px;
  color: white;
  cursor: pointer;
  background: none;
  border: none;
}

.notice-bar {
  height: 34px;
  padding: 8px 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #999;
  text-align: center;
  background-color: #fff9e6;
}

.main-content {
  padding: 0 16px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eee;
}

.titile {
  justify-content: flex-start;
}

.section-actions {
  display: flex;
  gap: 0;
}

.info-btn,
.share-btn {
  padding: 8px;
  color: #999;
  cursor: pointer;
  background: none;
  border: none;
}

.time-filter {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 16px;
}

.time-option {
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 2px;
}

.time-option.active {
  color: white;
  background-color: #007aff;
  border-color: #007aff;
}

.chart-container {
  width: 100%;
  height: calc(100vh - 130px);
  padding: 24px 8px;
  overflow: hidden;
  background-color: white;
  // border-radius: 8px;
}

.ranking-table {
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.table-header {
  display: flex;
  justify-content: center;

  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr; */
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eee;
}

.header-cell {
  width: 30%;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  text-align: left;
}

.sort-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: #999;

  &.sort-asc {
    color: #007aff;
  }

  &.sort-desc {
    color: #007aff;
  }
}

.table-body {
  /* display: grid; */

  /* display: flex; */

  /* grid-template-columns: 1fr 1fr 1fr; */

  /* justify-content: space-between; */
  width: 100%;
}

.table-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.cell {
  width: 30%;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.cell.positive {
  color: #8c000d;
}

.cell.negative {
  color: #2a9d8f;
}

.icon-group {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  margin: 12px;
  cursor: pointer;

  img {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}

.up {
  color: #f56c6c;
}

.down {
  color: #67c23a;
}
</style>
